<div class="progress-container">
  <div class="progress-bar" [style.width.%]="progressPercentage"></div>
  <div class="progress-bar-bg"></div>
  <div class="steps">
    <div *ngFor="let step of steps; let i = index" class="step" [ngClass]="{'disabled': isDisabled}" [class.completed]="step.checked">
      <button class="check-btn" [ngClass]="{'disabled': isDisabled}" type="button" (click)="!isDisabled ? selectStep(i) : null">
        <ion-icon name="checkmark-done-outline"></ion-icon>
      </button>
      <p class="step-label">{{ step.name }}</p>

      <!-- Notes container -->
      <div class="status-notes-container">
        <div class="position-relative">
          <button class="info-btn" (click)="openInfomationPopover($event, step)"><ion-icon name="information-circle-outline"></ion-icon></button>
          <button *ngIf="i == currentStep && !isDisabled" class="info-btn" style="color: var(--theme-color-blue);" (click)="openStatusNotesInput($event, step)"><ion-icon name="add-outline"></ion-icon></button>
        </div>
      </div>
    </div>
  </div>
</div>

